import * as React from "react";
const Lock = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 8.95817C14.6583 8.95817 14.375 8.67484 14.375 8.33317V6.6665C14.375 4.0415 13.6333 2.2915 10 2.2915C6.36667 2.2915 5.625 4.0415 5.625 6.6665V8.33317C5.625 8.67484 5.34167 8.95817 5 8.95817C4.65833 8.95817 4.375 8.67484 4.375 8.33317V6.6665C4.375 4.24984 4.95833 1.0415 10 1.0415C15.0417 1.0415 15.625 4.24984 15.625 6.6665V8.33317C15.625 8.67484 15.3417 8.95817 15 8.95817Z"
      fill="#969BA1"
    />
    <path
      d="M10.0013 16.0417C8.50964 16.0417 7.29297 14.825 7.29297 13.3333C7.29297 11.8417 8.50964 10.625 10.0013 10.625C11.493 10.625 12.7096 11.8417 12.7096 13.3333C12.7096 14.825 11.493 16.0417 10.0013 16.0417ZM10.0013 11.875C9.2013 11.875 8.54297 12.5333 8.54297 13.3333C8.54297 14.1333 9.2013 14.7917 10.0013 14.7917C10.8013 14.7917 11.4596 14.1333 11.4596 13.3333C11.4596 12.5333 10.8013 11.875 10.0013 11.875Z"
      fill="#969BA1"
    />
    <path
      d="M14.168 18.9585H5.83464C2.15964 18.9585 1.04297 17.8418 1.04297 14.1668V12.5002C1.04297 8.82516 2.15964 7.7085 5.83464 7.7085H14.168C17.843 7.7085 18.9596 8.82516 18.9596 12.5002V14.1668C18.9596 17.8418 17.843 18.9585 14.168 18.9585ZM5.83464 8.9585C2.8513 8.9585 2.29297 9.52516 2.29297 12.5002V14.1668C2.29297 17.1418 2.8513 17.7085 5.83464 17.7085H14.168C17.1513 17.7085 17.7096 17.1418 17.7096 14.1668V12.5002C17.7096 9.52516 17.1513 8.9585 14.168 8.9585H5.83464Z"
      fill="#969BA1"
    />
  </svg>
);
export default Lock;
